import DeleteForeverOutlinedIcon from '@mui/icons-material/DeleteForeverOutlined';
import { Button } from '@mui/material';

interface DeleteButtonProps {
  onClick: () => void;
  label?: string;
}

/**
 * 削除ボタンコンポーネント
 */
export const DeleteButton = ({ onClick, label }: DeleteButtonProps) => {
  return (
    <Button
      variant="outlined"
      size="small"
      color="error"
      startIcon={<DeleteForeverOutlinedIcon />}
      onClick={onClick}
    >
      {label}
    </Button>
  );
};

